export const P00061FonctionnementPAC = [
  { ref: 0, label: 'P00061.params.fonctionnementpac.cold' },
  { ref: 1, label: 'P00061.params.fonctionnementpac.hot' },
  { ref: 2, label: 'P00061.params.fonctionnementpac.auto' },
];
